import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    root: {
      zIndex: 10,
      position: 'relative',
      width: '100%',
      borderRadius: theme.shape.borderRadius,
      borderTopLeftRadius: (useStylesParams) =>
        useStylesParams.size === 'small' ? 0 : theme.shape.borderRadius,
      borderBottomLeftRadius: (useStylesParams) =>
        useStylesParams.size === 'small' ? 0 : theme.shape.borderRadius,
      boxShadow: theme.shadows[6],
      height: '100%',
      backgroundColor: theme.palette.background.paper,
      overflow: 'hidden',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      cursor:"default",
      '&::-webkit-scrollbar': {
        width: theme.shape.scrollSize,
        height: theme.shape.scrollSize,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.scroll,
        borderRadius: theme.shape.scrollRadius,
      },
    },
    header: {
      padding: 15,
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      boxShadow: theme.shadows[3],
      flexWrap: 'nowrap',
      justifyContent: 'space-between',
      zIndex: 10,
    },
    card: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      padding: '20px 30px 10px 30px',
      width: '90%',
      backgroundColor: theme.palette.background.paper2,
    },
    card_container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      flex: 1,
      gap: 20
    },
    divider:{
      marginTop: 10,
      marginBottom: 20,
      backgroundColor: theme.palette.background.default,
      boxShadow: theme.shadows[2],
      width: '90%',
      margin: 'auto',
    },
    content: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'nowrap',
      padding: '0px 30px',
      width: '90%',
      margin: 'auto',

      '& > div': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 5,
      },
    },
  }));

export default useStyles
